// Import images (adjust the relative paths to match your folder structure)
// Assuming this file is at src/utils/data/trustees.js
// and images are at src/assets/images/trustees/
import presidentImg from '../../assets/images/president.jpg';
import michaelImg from '../../assets/images/thomas.jpeg';
import sarahImg from '../../assets/images/onoja-prince.jpeg';
import jamesImg from '../../assets/images/silas.jpeg';
import graceImg from '../../assets/images/felix.jpeg';

export const trustees = [
  {
    id: 1,
    name: 'Prof Stephen Obekpa Abah MBBS, FWACP, FAPH, FRSPH',
    role: 'President',
    bio: 'Founding Chairman of IMDF, with decades of experience in medical practice and community development.',
    image: presidentImg, // imported image
  },
  {
    id: 2,
    name: 'Dr Thomas Omachoko',
    role: 'Secretary General',
    bio: 'Secretary General and one of the founding members, committed to advancing healthcare in Idoma land.',
    image: michaelImg,
  },
  {
    id: 3,
    name: 'Dr Onoja Prince ',
    role: 'PRO',
    bio: 'Immediate Past General Secretary',
    image: sarahImg,
  },
  {
    id: 4,
    name: 'Prof Silas Ochejele.',
    role: ' Immediate Past President (IPP & Ex officio member of Exco)',
    bio: 'Trustee with expertise in public health and policy advocacy.',
    image: jamesImg,
  },
  {
    id: 5,
    name: 'Dr Felix O. Ogbo ',      
    role: 'Immediate Past General Secretary',
    bio: 'Consultant General Surgeon, FMC Abuja',
    image: graceImg,
  },
];